import { Integrations } from "@sentry/tracing";
import * as Sentry from "@sentry/vue";

// message regex to ignore XHR requests errors as they are already logged in the backend
const axiosIgnoredErrors = [/^Network Error$/, /^Request aborted$/, /^Request failed with status code [0-9]{3}$/];

export const activateSentry = (router, app) => {
  if (import.meta.env.VITE_APP_SENTRY_DSN) {
    Sentry.init({
      app,
      dsn: import.meta.env.VITE_APP_SENTRY_DSN,
      ignoreErrors: [...axiosIgnoredErrors],
      integrations: [
        new Integrations.BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        }),
      ],
      tracesSampleRate: 0, // https://recommerce.atlassian.net/browse/CXCORE-4015
      denyUrls: [/gtm\.js/i],
      environment: import.meta.env.VITE_APP_SENTRY_ENV,
      release: import.meta.env.VITE_APP_RELEASE,
    });
  }
};

export const setSentryContext = (user) => {
  if (import.meta.env.VITE_APP_SENTRY_DSN) {
    Sentry.setUser(user ? { id: user.id } : null);
    const org = user?.getCurrentOrganization();
    Sentry.setContext("organization", org ? { commonName: org.commonName, id: org.id } : null);
  }
};
